import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, Button, Message } from 'semantic-ui-react';

// LIBS
import { Translate, I18n } from 'react-redux-i18n';

// REDUCERS
import {
  securityModalChange,
  clearSecurityDisableRecordMessages,
  disableSecurityModalChange
} from './reducer';

// COMPONENTS
import DisableSecurityModal from './MFA/disableSecurityModal';
import PasskeysPanel from './passkeys/PasskeysPanel';
import { Record } from '../../../modules/bin/utility';

class Security extends Component {
  handleSecurityModalOpen = () => {
    this.props.securityModalChange(true);
  };

  handleDisableSecurityModal = () => {
    this.props.disableSecurityModalChange(true);
  };

  handleDisableSecurityMessageSuccess = () => {
    this.props.clearSecurityDisableRecordMessages('disableSecurityRecord');
  };

  render() {
    const isMfaActive = this.props.accountDetail?.hasMfaActive;
    const enforcingCampaignOrganizer = this.props.session?.campaignOrganizers?.find(
      (x) => x?.isAtLeastOneLinkedOrganizationMfaActive
    );
    const organization =
      this.props.session?.organization ||
      this.props.session?.campaigns?.find((x) => x.organization?.hasMfaActive)
        ?.organization ||
      (enforcingCampaignOrganizer && { name: enforcingCampaignOrganizer.name, hasMfaActive: true });
    const isOrgMfaActive =
      organization?.hasMfaActive ||
      this.props.session?.campaignOrganizers?.some(
        (x) => x?.isAtLeastOneLinkedOrganizationMfaActive
      );

    return (
      <React.Fragment>
        <DisableSecurityModal />
        <div className="security-container">
          {/* Plain Messages rather than RecordResultMessage: that component is
              position:absolute;top:0 with a z-index, and the sibling rule that offsets the
              content below it landed on the modal instead, so the banner sat on top of the card.
              The invalid-code case is reported inside DisableSecurityModal, so what reaches here
              is the confirmation and anything the modal could not account for. */}
          {Record.isSuccess(this.props.disableSecurityRecord) && (
            <Message
              positive
              size="small"
              onDismiss={this.handleDisableSecurityMessageSuccess}
            >
              <Message.Content>
                {I18n.t('security.disable-tab-success-message')}
              </Message.Content>
            </Message>
          )}
          {Record.isError(this.props.disableSecurityRecord) && (
            <Message
              negative
              size="small"
              onDismiss={this.handleDisableSecurityMessageSuccess}
            >
              <Message.Content>
                {I18n.t('general.general-error-message')}
              </Message.Content>
            </Message>
          )}
          <Card fluid>
            <div className="security-content-container">
              <Card.Content>
                <h3 className="security-title">
                  <Translate value={'account.account-security.general.title'} />
                </h3>
                <div className="security-instructions">
                  <span className="instructions-text">
                    <Translate
                      value={'account.account-security.general.instructions'}
                    />
                  </span>
                </div>
                <div
                  className={`mfa-container ${isMfaActive ? 'active' : 'disabled'
                    }`}
                >
                  {isMfaActive && (
                    <React.Fragment>
                      <div className="security-active-button-container">
                        <Button
                          className="mfa-button"
                          floated="left"
                          disabled={isOrgMfaActive}
                          onClick={this.handleDisableSecurityModal}
                        >
                          <Translate
                            value={
                              'account.account-security.general.activated.button'
                            }
                          />
                        </Button>
                      </div>
                      <span className="security-active-title">
                        <Translate
                          value={
                            'account.account-security.general.activated.title'
                          }
                        />
                      </span>
                      {isOrgMfaActive && (
                        <span className="security-active-force-mfa-note">
                          {organization?.name ? (
                            <Translate
                              value="account.account-security.general.activated.forceMfa"
                              orgName={organization.name}
                            />
                          ) : (
                            <Translate value="account.account-security.general.activated.forceMfaNoOrganization" />
                          )}
                        </span>
                      )}
                    </React.Fragment>
                  )}
                  {!isMfaActive && (
                    <Button
                      primary
                      className="mfa-button"
                      floated="left"
                      onClick={this.handleSecurityModalOpen}
                    >
                      <Translate
                        value={
                          'account.account-security.general.disabled.button'
                        }
                      />
                    </Button>
                  )}
                </div>
              </Card.Content>
            </div>
          </Card>
          <PasskeysPanel accountId={this.props.accountDetail?.id} hasMfaActive={!!isMfaActive} />
        </div>
      </React.Fragment>
    );
  }
}

const mapState = ({ accountSettings, session }) => {
  return {
    session: session,
    accountDetail: accountSettings.record.data.data,
    disableSecurityRecord: accountSettings.disableSecurityRecord,
    isLoading: Record.isRecordLoading(accountSettings.disableSecurityRecord)
  };
};

const mapDispatch = (dispatch) => {
  return {
    securityModalChange: (open) => {
      dispatch(securityModalChange(open));
    },
    disableSecurityModalChange: (open) => {
      dispatch(disableSecurityModalChange(open));
    },
    clearSecurityDisableRecordMessages: (record) => {
      dispatch(clearSecurityDisableRecordMessages(record));
    }
  };
};

export default connect(mapState, mapDispatch)(Security);
